'use strict';
Object.defineProperty(exports, '__esModule', { value: true });
var prefix = 'fasds';
var iconName = 'umbrella-beach';
var width = 512;
var height = 512;
var aliases = [127958];
var unicode = 'f5ca';
var svgPathData = ['M0 448l0 64 512 0 0-64-324.2 0 88.8-177.7 1.6-3.2-57.2-28.6-1.6 3.2-103.2 206.3-116.2 0z', 'M485 370.5C502.3 336.1 512 297.2 512 256 512 114.6 397.4 0 256 0 155.8 0 69 57.6 27 141.5l458 229z'];

exports.definition = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    aliases,
    unicode,
    svgPathData
  ]};

exports.faUmbrellaBeach = exports.definition;
exports.prefix = prefix;
exports.iconName = iconName;
exports.width = width;
exports.height = height;
exports.ligatures = aliases;
exports.unicode = unicode;
exports.svgPathData = svgPathData;
exports.aliases = aliases;